// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"bd57d494","40":"ecd66010","80":"ee959fa7","112":"c9e94182","156":"9a9a2272","441":"d259287b","592":"99c0a167","620":"567dcec0","632":"33037ba4","664":"806f41bd","672":"195116b5","792":"f1daa1bc","872":"cb60b852","888":"088d864a","936":"06aa487c"}[chunkId] + ".chunk.js";
};